import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import LocalizedText from '@LocalizedText';
import { inject } from '@app/providers/QAU.ContextProvider';
import { HELP_SECTION_UPLOAD_ART, HELP_TOPIC_UPLOAD_ART_PREPARE_FILES } from '@app/constants';

import DropZone from '@components/drop-zone/DropZone';
import HelpTip from '@components/help/help-tip/HelpTip';
import FileInput from '@components/buttons/file-input-btn/FileInput';

import './UploadArtwork.scss';

const getSupportedTypes = fc => {
  const extensions = [];
  const mimeTypes = [];

  const fcFormats = fc.imageProcessing?.formats?.items || [];

  fcFormats.forEach(({ mimeType, extension }) => {
    const ext = `.${extension}`;
    !extensions.includes(ext) && extensions.push(ext);
    !mimeTypes.includes(mimeType) && mimeTypes.push(mimeType);
  });

  return {
    mimeTypes: mimeTypes.join(', '),
    extensions: extensions.join(', '),
  };
};

const getAcceptList = extensions => {
  const hasPsd = extensions.toLowerCase().includes('psd');
  hasPsd && (extensions = `${extensions}, image/psd`); // Required for iOS devices to enable '*.psd' files upload
  return extensions;
};

const UploadArtwork = ({ flowConfig, handleFileSelect, resetSelectedFile, isMobileView }) => {
  const [supportedExtensions, setSupportedExtensions] = useState();
  const [supportedAcceptList, setSupportedAcceptList] = useState();

  useEffect(() => {
    const { extensions } = getSupportedTypes(flowConfig);
    const acceptList = getAcceptList(extensions);

    setSupportedExtensions(extensions);
    setSupportedAcceptList(acceptList);
  }, [flowConfig]);

  return (
    <div className="upload-artwork">
      <HelpTip
        tipLocKey="qau-upload-prepare-files"
        helpSection={HELP_SECTION_UPLOAD_ART}
        helpTopic={HELP_TOPIC_UPLOAD_ART_PREPARE_FILES}
      />
      {isMobileView ? (
        <FileInput
          handleFileSelect={file => {
            resetSelectedFile();
            handleFileSelect(file);
          }}
          locKey="qau-upload-choose-file"
          accept={supportedAcceptList}
        />
      ) : (
        <DropZone
          titleLocKey="qau-upload-drop-file"
          fileBtnLocKey="qau-upload-choose-file"
          resetSelectedFile={resetSelectedFile}
          handleFileSelect={handleFileSelect}
          supportedTypes={supportedAcceptList}
        />
      )}
      <div className="supported-types">
        <LocalizedText id="qau-upload-supported-types" values={{ supportedExtensions }} />
      </div>
    </div>
  );
};

UploadArtwork.propTypes = {
  flowConfig: PropTypes.object,
  isMobileView: PropTypes.bool.isRequired,
  handleFileSelect: PropTypes.func.isRequired,
  resetSelectedFile: PropTypes.func.isRequired,
};

export default inject('flowConfig')(UploadArtwork);
